export const formValuesMaster = {
  region: 'ca-central-1',
  channelName: '',
  clientId: 'Master',
  sendVideo: true,
  sendAudio: false,
  openDataChannel: true,
  widescreen: false,
  fullscreen: false,
  useTrickleICE: true,
  natTraversalDisabled: false,
  forceTURN: false,
  accessKeyId: '',
  endpoint: null,
  secretAccessKey: '',
  sessionToken: null
}

export const formValuesMasterSnugHealth = {
  region: 'ap-southeast-2',
  channelName: '',
  clientId: 'Master',
  sendVideo: true,
  sendAudio: false,
  openDataChannel: true,
  widescreen: false,
  fullscreen: false,
  useTrickleICE: true,
  natTraversalDisabled: false,
  forceTURN: false,
  accessKeyId: '',
  endpoint: null,
  secretAccessKey: '',
  sessionToken: null
}

export const CognitoIdentityPoolCA = {
  region: 'ca-central-1',
  identityPoolId: 'ca-central-1:5de98422-b688-44e3-a28c-fbb427ee550f',
  roleArn:
    'arn:aws:iam::030590469202:role/Cognito_VeyetalsDoctorCallIdentityPoolUnauth_Role'
}